<mat-card>
  <mat-card-content class="w-full overflow-x-auto">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      [attr.data-cy]="testIds.WORKSHOP_JOB_LIST_TABLE"
    >
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="id">ID</th>
        <td mat-cell *matCellDef="let element">
          <a [routerLink]="['job', element.id]">{{ element.id }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.customer; else internal">
            {{ element.customer }}
            <a [routerLink]="['/repair-docket', element.docket_id]"
              >({{ element.docket_id }})</a
            >
          </ng-container>
          <ng-template #internal><em>Internal</em></ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="equipment">
        <th mat-header-cell *matHeaderCellDef>Equipment</th>
        <td mat-cell *matCellDef="let element">{{ element.equipment }}</td>
      </ng-container>

      <ng-container matColumnDef="booked_in_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="booked_in_at">
          Booked in
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.booked_in_date | amDateFormat: dateFormat }}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="work_status">
          Status
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.status | workshopJobStatusLabel }}
        </td>
      </ng-container>
      <ng-container matColumnDef="assigned_to">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="assigned_to">
          Assigned To
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.assigned_to | userIdToName | async }}
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</th>
        <td mat-cell *matCellDef="let element">{{ element.type }}</td>
      </ng-container>
      <ng-container matColumnDef="booked_in_location">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header="booked_in_location"
        >
          Booked in location
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.booked_in_location_id | locationNameFromId | async }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let element"></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns$ | async"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns$ | async"></tr>
    </table>

    <div class="flex flex-row justify-end items-center">
      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        pageSize="10"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
      <button
        mat-icon-button
        matTooltip="Export to Excel"
        (click)="excelExport()"
      >
        <mat-icon>download</mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>
